exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/images/search/ios-search.svg"));

// Module
exports.push([module.id, ".searchContainer-273120da{padding:20px 20px;border-bottom:1px solid #E0E0E0}.searchInput-0b73f944{border-radius:999px;border:1px solid #E0E0E0;height:40px;line-height:40px;outline:none;width:100%;padding:0 30px 0 45px;background:url(" + ___CSS_LOADER_URL___0___ + ") no-repeat 15px center/20px,#fff}.chips-7813c906{margin-top:10px}.resultsCount-96166227{margin-top:10px;margin-bottom:-10px;color:#757575;font-size:15px}.resultsFooter-696b8be1{padding:20px;text-align:center}.footerText-d24a1136{font-style:italic;color:#757575}\n", ""]);

// Exports
exports.locals = {
	"searchContainer": "searchContainer-273120da",
	"searchInput": "searchInput-0b73f944",
	"chips": "chips-7813c906",
	"resultsCount": "resultsCount-96166227",
	"resultsFooter": "resultsFooter-696b8be1",
	"footerText": "footerText-d24a1136"
};